// extracted by mini-css-extract-plugin
export default {"fastPlaceGhostContainer":"fast-place-ghost_fastPlaceGhostContainer__3Gh-5"};